module.exports = __webpack_public_path__ + "img/ssmartlocator.9c21696a.svg";